// LF360-2016 — the articles a scenario's Suggestions point at, and which of
// them are not what the editor can offer.
//
// The editor offers the active row of every switched-on article of the project
// and shows any other stored id as a bare id marked "deleted". The backend says
// what each id really is (POST /v1/pages/reference-states); these are the words
// for it, and they say what the subject gets: a draft row or an old-format id is
// still delivered as the published article, while a deleted, switched-off or
// other project's article is not delivered at all.

export const REFERENCE_REASONS = {
  deleted: "deleted — subjects don't receive it",
  switched_off: "switched off — subjects don't receive it",
  draft_row: "an unpublished version is selected — subjects receive the published one",
  group_id: "stored in an old format — subjects still receive it",
  other_project: "an article of another project — subjects don't receive it",
};

/** Every distinct article id the Suggestions nodes of a graph name. */
export const collectArticleIds = (graph) => {
  if (!graph || typeof graph !== "object") return [];

  const ids = new Set();
  for (const node of Object.values(graph)) {
    const data = node?.data;
    if (data?.nodeType !== "message:suggestions") continue;
    const stored = data.articles?.ids;
    if (Array.isArray(stored)) stored.forEach((id) => typeof id === "string" && ids.add(id));
  }

  return [...ids];
};

/** The references to show, as one line each; available ones are left out. */
export const unavailableLines = (references = []) =>
  references
    .filter((ref) => ref.state !== "available")
    .map((ref) => ({
      id: ref.id,
      title: ref.title || null,
      reason: REFERENCE_REASONS[ref.state] || ref.state,
    }));
